import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";

export default function AkunLayout() {
  if (
    localStorage.getItem("access_token") === null ||
    localStorage.getItem("refresh_token") === null
  ) {
    console.log("trigger");
    window.location.replace("/");
  }

  return <Outlet></Outlet>;
}
